import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';

import { BannerLayoutType, Link } from '@hdms/shared/common-types';

import { ButtonModule } from '../button';
import { FlyoutModule } from '../flyout';
import { ImageModule } from '../image/image.module';
import { InfoBoxModule } from '../info-box';
import { IconsName, SvgIconModule } from '../svg-icon';

export interface CtaClickData {
  event: MouseEvent;
  data: Link;
}

@Component({
  selector: 'shrd-uic-marketing-banner',
  standalone: true,
  imports: [CommonModule, SvgIconModule, ImageModule, ButtonModule, InfoBoxModule, FlyoutModule],
  templateUrl: './marketing-banner.component.html',
  styleUrls: ['./marketing-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MarketingBannerComponent {
  @Input() headline: string;
  @Input() subHeadline: string;
  @Input() buttons: Link[];
  @Input() closeButtonLabel: string;
  @Input() dontShowAgainButtonLabel: string;
  @Input() layoutType: BannerLayoutType;

  @Input() imageUrl?: string;
  @Input() imageAlt?: string;

  @Output() ctaButtonClick = new EventEmitter<CtaClickData>();
  @Output() closeButtonClick = new EventEmitter<void>();
  @Output() dontShowAgainButtonClick = new EventEmitter<void>();

  iconsSet = IconsName;

  @HostBinding('class.lifestyle')
  get isLifestyle(): boolean {
    return this.layoutType === BannerLayoutType.LIFESTYLE;
  }

  @HostBinding('class.has-image')
  get hasImage(): boolean {
    return this.layoutType !== BannerLayoutType.NO_IMAGE;
  }

  @HostBinding('class.shrd-uic-marketing-banner')
  private readonly hostClass = true;
}
